import { render } from "./user_onboarding_modal.vue?vue&type=template&id=e435e526"
import script from "./user_onboarding_modal.vue?vue&type=script&lang=js"
export * from "./user_onboarding_modal.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployer/asset-portal/releases/20260828153143/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__